import { render, staticRenderFns } from "./SidebarObjectsInput.vue?vue&type=template&id=3608c3e0&scoped=true&"
import script from "./SidebarObjectsInput.vue?vue&type=script&lang=js&"
export * from "./SidebarObjectsInput.vue?vue&type=script&lang=js&"
import style0 from "./SidebarObjectsInput.vue?vue&type=style&index=0&id=3608c3e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3608c3e0",
  null
  
)

export default component.exports